import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Heart, Globe } from 'lucide-react';
import './EndSlide.css';

function EndSlide({ showNotes }) {
  return (
    <div className="slide end-slide">
      {/* Animated Background Elements */}
      <div className="end-bg-elements">
        <motion.div
          className="bg-circle circle-1"
          animate={{ 
            scale: [1, 1.2, 1],
            opacity: [0.1, 0.2, 0.1]
          }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="bg-circle circle-2"
          animate={{ 
            scale: [1.2, 1, 1.2],
            opacity: [0.1, 0.15, 0.1]
          }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>

      <div className="end-content">
        {/* Thank You Message */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="thank-you-container"
        >
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="heart-icon"
          >
            <Heart size={40} fill="currentColor" />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="thank-you-text"
          >
            Vielen Dank für eure
            <br />
            <span className="highlight">Aufmerksamkeit!</span>
          </motion.h1>

          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ delay: 0.8, duration: 0.6, ease: "easeOut" }}
            className="end-divider"
          />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.5 }}
            className="questions-prompt"
          >
            <MessageCircle size={24} />
            <span>Fragen?</span>
          </motion.div>
        </motion.div>

        {/* Presentation Stats */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.4, duration: 0.5 }}
          className="presentation-stats"
        >
          <div className="stat-item">
            <span className="stat-value">12</span>
            <span className="stat-label">Folien</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-value">7</span>
            <span className="stat-label">Themenbereiche</span>
          </div>
        </motion.div>
      </div>

      {showNotes && (
        <div className="speaker-notes">
          <strong>📚 Zusatzinfos für Leser:</strong><br/>
          Diese Präsentation wurde für den Politikunterricht der Klasse 12FO21 erstellt 
          und im Januar 2026 gehalten.<br/><br/>
          <strong>Weiterführende Ressourcen:</strong><br/>
          • Bundeszentrale für politische Bildung (bpb.de)<br/>
          • Verfassungsschutz-Jahresberichte<br/>
          • Amadeu Antonio Stiftung<br/>
          • Belltower News (Monitoring rechtsextremer Aktivitäten)<br/><br/>
          Bei Fragen zu den Inhalten oder Quellen stehen wir gerne zur Verfügung.
        </div>
      )}
    </div>
  );
}

export default EndSlide;
